export function ConnectButton() {
  return <appkit-button />;
}
